export default [
  {
    path: '/apps/workflow-direcionamento/list',
    name: 'apps-workflow-direcionamento-list',
    component: () => import('@/views/app/worflow/workflow-direcionamento/list/Index.vue'),
    meta: {
      pageTitle: 'WorkFlow Direcionamento',
    },
  },
];
